let inject = [
  '$scope',
  '$state',
  '$rootScope',
  'SharedService',
  'ngAuthSettings'
];

class DynamicBannerController{
  constructor ($scope, $state, $rootScope, SharedService, ngAuthSettings) {
    this.$state = $state;
    this.$scope = $scope;
    this.ngAuthSettings = ngAuthSettings;
    this.$rootScope = $rootScope;
    this.SharedService = SharedService;
  }
  
}

DynamicBannerController.$inject = inject;

export default DynamicBannerController;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shared/components/banners/dynamic-banner/dynamic-banner.controller.js
 **/